import { useFormik } from 'formik'
import React, { useRef } from 'react'
import * as Yup from 'yup'
import { Edit_Subdivision } from '../../Edit_Propetry/Edit_Propetry_Api'
import Swal from 'sweetalert2'
import { editSubdivisionDetailsDataType } from '../../PropertyDataTypes'

interface editSubdivisionDataType{
    editSubmitRef: React.MutableRefObject<null>
    editFormRef: React.MutableRefObject<null>
    editSubdivisionDetails: editSubdivisionDetailsDataType
    get_view_property: ()=>Promise<void>, 
    setEditSubdivisions: (editSubdivisions: string)=>void
    setEditSubdivisionsLoading: (editSubdivisionsLoading: boolean)=>void, 
    editSubdivisionsLoading: boolean
}

const validationSchema = Yup.object().shape({
    property_unit_name: Yup.string().required('Subdivision name is required.'),
    property_unit_description: Yup.string().required('Property description is required.'),
    property_unit_max_tenants: Yup.number()
        .typeError('Please enter a valid number')
        .integer('Please enter an integer')
        .required('Number of tenants is required')
        .positive('Please enter positive integer'),
    property_unit_rent: Yup.number()
        .typeError('Please enter a valid number')
        .integer('Please enter an integer')
        .required('Expected rent is required')
        .positive('Please enter positive integer'),
})

const EditSubdivision = ({ editSubmitRef, editFormRef, editSubdivisionDetails, get_view_property, setEditSubdivisions, setEditSubdivisionsLoading, editSubdivisionsLoading }: editSubdivisionDataType) => {
    const handleSubmit = () => {
        formik.validateForm().then(async (error: any) => {
            if (Object.keys(error).length === 0) {
                setEditSubdivisionsLoading(true)
                try {
                    const { data: res } = await Edit_Subdivision(
                        editSubdivisionDetails.property_sub_unit_uuid,
                        formik.values.property_unit_description,
                        Number(formik.values.property_unit_max_tenants),
                        formik.values.property_unit_name,
                        formik.values.property_unit_rent
                    )
                    if (res.code === '200') {
                        setEditSubdivisionsLoading(false)
                        Swal.fire({
                            position: 'center',
                            icon: 'success',
                            title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
                            text: res.msg_details,
                            allowOutsideClick: true,
                        })
                        // getProperty()
                        get_view_property()
                        setEditSubdivisions("list")
                        formik.resetForm()
                    } else {
                        setEditSubdivisionsLoading(false)
                        Swal.fire({
                            position: 'center',
                            icon: 'error',
                            title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
                            text: res.msg_details,
                            allowOutsideClick: true,
                        })
                    }
                }
                catch (error: any) {
                    Swal.fire({
                        position: 'center',
                        icon: 'error',
                        title: 'Error',
                        text: error,
                        allowOutsideClick: true,
                    })
                }
                finally {
                    setEditSubdivisionsLoading(false)
                }
            } else {
                const firstErrorField = Object.keys(error)[0]
                if (firstErrorField) {
                    // @ts-ignore
                    const fieldElement = formRef.current?.elements[firstErrorField] as
                        | HTMLElement
                        | undefined
                    if (fieldElement) {
                        fieldElement.scrollIntoView({ behavior: 'smooth' })
                    }
                }
            }
        })
    }

    const formik = useFormik({
        initialValues: editSubdivisionDetails,
        enableReinitialize: true,
        validationSchema,
        onSubmit: () => handleSubmit(),
    })

    return (
        <form ref={editFormRef} onSubmit={formik.handleSubmit} className='form'>
            <div className='card-body p-9 row'>
                {/*begin::Form Group */}
                <div className='row mb-6'>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                        <span className='fw-bold fs-3'>Edit subdivision</span>
                    </label>
                </div>
                {/*end::Form Group */}
                <>
                    <div className='row mb-6'>
                        <div className='col-lg-6 col-12'>
                            <div>
                                {/*begin::Form Group property title */}
                                <div className='fv-row'>
                                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                                        <span className='required'>Subdivision Name</span>
                                        <i
                                            className='fas fa-exclamation-circle ms-2 fs-7'
                                            data-bs-toggle='tooltip'
                                            title='Enter subdivision name'
                                        ></i>
                                    </label>
                                    <input
                                        type='text'
                                        className='form-control form-control-lg form-control-solid'
                                        placeholder='Enter subdivision name'
                                        {...formik.getFieldProps(
                                            `property_unit_name`
                                        )}
                                    />
                                    <div className='h-20px'>
                                        {formik.touched.property_unit_name &&
                                            formik.errors.property_unit_name && (
                                                <div className='fv-help-block color-red'>
                                                    {
                                                        formik.errors.property_unit_name.toString()
                                                    }
                                                </div>
                                            )}
                                    </div>
                                </div>
                                {/*end::Form Group */}
                            </div>
                            <div className=''>
                                {/*begin::Form Group property title */}
                                <div className='fv-row'>
                                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                                        <span className='required'>Number of Tenant</span>
                                        <i
                                            className='fas fa-exclamation-circle ms-2 fs-7'
                                            data-bs-toggle='tooltip'
                                            title='Enter number of tenant'
                                        ></i>
                                    </label>
                                    <input
                                        type='text'
                                        className='form-control form-control-lg form-control-solid'
                                        placeholder='Enter number of tenant'
                                        {...formik.getFieldProps(
                                            `property_unit_max_tenants`
                                        )}
                                        name={`property_unit_max_tenants`}
                                        disabled
                                    />
                                    <div className='h-20px'>
                                        {formik.touched.property_unit_max_tenants &&
                                            formik.errors.property_unit_max_tenants && (
                                                <div className='fv-help-block color-red'>
                                                    {
                                                        formik.errors.property_unit_max_tenants.toString()
                                                    }
                                                </div>
                                            )}
                                    </div>
                                </div>
                                {/*end::Form Group */}
                            </div>
                            <div className=''>
                                {/*begin::Form Group property title */}
                                <div className='fv-row'>
                                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                                        <span className='required'>Expected Rent</span>
                                        <i
                                            className='fas fa-exclamation-circle ms-2 fs-7'
                                            data-bs-toggle='tooltip'
                                            title='Enter expected rent'
                                        ></i>
                                    </label>
                                    <input
                                        type='text'
                                        className='form-control form-control-lg form-control-solid'
                                        placeholder='Enter expected rent'
                                        {...formik.getFieldProps(
                                            `property_unit_rent`
                                        )}
                                    />
                                    <div className='h-20px'>
                                        {formik.touched.property_unit_rent &&
                                            formik.errors.property_unit_rent && (
                                                <div className='fv-help-block color-red'>
                                                    {
                                                        formik.errors.property_unit_rent.toString()
                                                    }
                                                </div>
                                            )}
                                    </div>
                                </div>
                                {/*end::Form Group */}
                            </div>
                        </div>
                        <div className='col-lg-6 col-12'>
                            <div className=''>
                                {/*begin::Form Group property title */}
                                <div className='fv-row'>
                                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                                        <span className='required'>Subdivision Description</span>
                                        <i
                                            className='fas fa-exclamation-circle ms-2 fs-7'
                                            data-bs-toggle='tooltip'
                                            title='Enter subdivision description'
                                        ></i>
                                    </label>
                                    <textarea
                                        rows={9}
                                        cols={200}
                                        disabled={false}
                                        className='form-control form-control-lg form-control-solid'
                                        placeholder='Enter subdivision description'
                                        {...formik.getFieldProps(
                                            `property_unit_description`
                                        )}
                                        name={`property_unit_description`}
                                    />
                                    <div className='h-20px'>
                                        {formik.touched.property_unit_description &&
                                            formik.errors.property_unit_description && (
                                                <div className='fv-help-block color-red'>
                                                    {
                                                        formik.errors.property_unit_description.toString()
                                                    }
                                                </div>
                                            )}
                                    </div>
                                </div>
                                {/*end::Form Group */}
                            </div>
                        </div>
                    </div>
                </>
                <div className='card-footer d-flex justify-content-end py-6 px-3'>
                    <button
                        className='btn btn-sm btn-light fw-bold bg-color-white shadow me-4 btn-active-light-primary'
                        onClick={() => setEditSubdivisions("list")}
                    >
                        Cancel
                    </button>
                    <button
                        type='submit'
                        className='btn btn-sm btn-primary shadow'
                        ref={editSubmitRef}
                        disabled={editSubdivisionsLoading}
                    >
                        {editSubdivisionsLoading ? (
                            <span className='indicator-progress' style={{ display: 'block' }}>
                                Processing...
                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                            </span>
                        ) : (
                            'Save'
                        )}
                    </button>
                </div>
            </div>
        </form>
    )
}

export default EditSubdivision